<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.deptIds"
        placeholder="工作单位"
        multiple
      >
        <el-option
          v-for="(item, i) in workUnitData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn_170">
        <el-select
          class="select_btn_style"
          v-model="filters.lines"
          placeholder="单位所属条线(多选)"
          multiple
        >
          <el-option
            v-for="(item, i) in lineData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.positionTag"
        placeholder="职务层次"
        multiple
      >
        <el-option
          v-for="(item, i) in jobData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.positionLevel"
        placeholder="职级"
        multiple
      >
        <el-option
          v-for="(item, i) in jobLevelData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.sex"
        placeholder="性别"
      >
        <el-option
          v-for="(item, i) in genderData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.politics"
        placeholder="政治面貌"
        multiple
      >
        <el-option
          v-for="(item, i) in policyData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.education"
        placeholder="学历"
        multiple
      >
        <el-option
          v-for="(item, i) in degreeData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        size="small"
        v-model.trim="filters.name"
        placeholder="姓名"
      ></el-input>
    </el-form-item>
    <el-form-item label="出生年月：">
      <el-date-picker
        v-model="filters.month"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getEnum } from "@/utils/common";
import { queryCondition } from "@/api/groupManage";

export default {
  components: { butn },
  props: {
    classId: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      filters: {},
      workUnitData: [],
      jobData: [],
      jobLevelData: [],
      genderData: [],
      policyData: [],
      degreeData: [],
      lineData: [],
    };
  },
  created() {
    getEnum("USER_SEX", this, "genderData");
    this.getCondition([0, 1, 2, 3, 4, 5]);
  },
  methods: {
    getCondition(conditionTypes) {
      queryCondition({ classId: this.classId, conditionTypes }).then(
        ({ code, data }) => {
          if (code !== 0) return;
          let { dept, education, politics, positionLevel, positionTag, line = [] } = data;
          this.workUnitData = dept;
          this.jobData = positionTag;
          this.jobLevelData = positionLevel;
          this.policyData = politics;
          this.degreeData = education;
          this.lineData = line;
        }
      );
    },
    initData() {
      let params = {};
      Object.keys(this.filters).forEach((x) => {
        if (Array.isArray(this.filters[x])) {
          params[x] = this.filters[x].join(",");
        } else {
          params[x] = this.filters[x];
        }
      });
      if (Array.isArray(this.filters.month) && this.filters.month.length > 1) {
        params["startDate"] = this.filters.month[0];
        params["endDate"] = this.filters.month[1];
      }
      this.$emit("search", { ...params });
    },
    resetData() {
      this.filters = {};
      this.initData();
    },
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
</style>
